import React, { useState } from "react";
import { Table, Row, Col, Button, Space, message } from "antd";
import { removeRevokedLicense } from "../../../../../services/vendorProfile.services";
import RevokedLicenseModal from "./RevokedLicenseModal";
import { confirmModal } from "../../../../../reusable/ModalWizz";
import { RevokedLicenseColumns } from "../../../../PQQ/tableColumns";

const RevokedLicense = (props) => {
  const [visible, setVisible] = useState(false);
  const [editTable, setEditTable] = useState(null);

  const refreshPage = () => {
    props.fetchRevokedLicense(props.vendorId);
  };

  const openModal = (data) => {
    setVisible(true);
    setEditTable(data);
  };

  const removeColumn = (id) => {
    removeRevokedLicense({
      id: id,
      vendor_id: props.vendorId,
    })
      .then((response) => {
        refreshPage();
        message.success(response.data.message);
      })
      .catch((error) => {
        message.error(error.response.data.message);
      });
  };

  const columns = [
    ...RevokedLicenseColumns,
    {
      title: "Action",
      key: "action",
      render: (record) => (
        <Space size="middle">
          <span
            className="footer-links"
            onClick={() => openModal({ ...record, status: "update" })}
          >
            Edit
          </span>
          <span
            className="footer-links"
            onClick={() => {
              confirmModal({
                title: `Are you sure to delete this record?`,
                onOk: () => removeColumn(record.id),
              });
            }}
          >
            Delete
          </span>
        </Space>
      ),
    },
  ];

  return (
    <Row>
      <Col span={22} offset={1}>
        <Button
          onClick={openModal}
          type="secondary"
          style={{
            marginBottom: 16,
          }}
        >
          Add Revoked License
        </Button>
        <Table
          size="small"
          columns={columns}
          dataSource={props.revokedLicenseData}
          pagination={false}
          scroll={{ x: 800 }}
        />
      </Col>
      {visible && (
        <RevokedLicenseModal
          setVisible={setVisible}
          title="Add Revoked License"
          vendorId={props.vendorId}
          editTable={editTable}
          refresh={refreshPage}
        />
      )}
    </Row>
  );
};

export default RevokedLicense;
